<div class="help-feedback-wrapper">
  <button (click)="openHelp(helpContent)" 
          class="need-help-button d-flex align-items-center"
          title="Get help or provide feedback">
    <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1732604544778message-question.png"
         alt="Help Icon" class="help-icon me-2">
    <span class="d-none d-md-inline">Need Help?</span>
  </button>
</div>

<ng-template #helpContent let-c="close" let-d="dismiss">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Help and Support</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body">
      
      <!-- ✅ Removed dataProcessor and onSubmitResponse - using onClick instead -->
      <formly-form 
        [model]="model" 
        [fields]="layout"
        [options]="options"
        [form]="form">
      </formly-form>

      <div *ngIf="model.category === 'Feedback'" class="custom-feedback-section mt-3 mb-4">
        
        <div class="emoji-question-group mb-4">
          <label class="form-label">
            How was your experience with our platform? 
            <span class="text-danger">*</span>
          </label>
          <div class="emoji-grid">
            <div *ngFor="let option of feedbackOptions" 
                 class="emoji-card"
                 [class.selected]="isEmojiSelected('experience', option.value)"
                 (click)="selectEmoji('experience', option.value)">
              <div class="emoji-icon">{{ option.emoji }}</div>
              <div class="emoji-label">{{ option.label }}</div>
            </div>
          </div>
        </div>

        <div class="emoji-question-group mb-4">
          <label class="form-label">
            Did you find the course recommendations helpful? 
            <span class="text-danger">*</span>
          </label>
          <div class="emoji-grid">
            <div *ngFor="let option of feedbackOptions" 
                 class="emoji-card"
                 [class.selected]="isEmojiSelected('courseDiscovery', option.value)"
                 (click)="selectEmoji('courseDiscovery', option.value)">
              <div class="emoji-icon">{{ option.emoji }}</div>
              <div class="emoji-label">{{ option.label }}</div>
            </div>
          </div>
        </div>

        <div class="emoji-question-group mb-4">
          <label class="form-label">
            How clear was the application process information? 
            <span class="text-danger">*</span>
          </label>
          <div class="emoji-grid">
            <div *ngFor="let option of feedbackOptions" 
                 class="emoji-card"
                 [class.selected]="isEmojiSelected('applicationProcess', option.value)"
                 (click)="selectEmoji('applicationProcess', option.value)">
              <div class="emoji-icon">{{ option.emoji }}</div>
              <div class="emoji-label">{{ option.label }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- ✅ Removed dataProcessor and onSubmitResponse -->
      <formly-form 
        *ngIf="model.category === 'Feedback'"
        [model]="model" 
        [fields]="textFieldsLayout"
        [options]="options"
        [form]="form">
      </formly-form>
      
    </div>
  </div>
</ng-template>